module.exports = __webpack_public_path__ + "img/r_game_icon_04.d9a7b6b2.png";